<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Manage Employees" v-if="loading">Loading, please wait...</b-card>
				<b-card header="Manage Employees" v-else>

					<b-alert variant="info" show v-if="this.currentUser.role != 'administrator'">You must be an administrator to edit this page</b-alert>

					<!--<b-form-checkbox :plain="true"><small>Show Inactive Employees</small></b-form-checkbox><br><br>-->

					<div><small>
						Employees must have valid email to receive temporary password<br>
						Employees set to inactive will be archived and can no longer sign in<br>
					</small></div>
					<br>

					<b-table hover="true" striped="true" bordered="true" small="true" responsive="md" :items="items" :fields="fields" current-page="1" per-page="500">
						
						<template slot="email" slot-scope="data">
								<b-form-input v-if="data.index == (items.length - 1)" size="sm" v-model="data.item.email" v-on:change="addNewEmployee"></b-form-input>
								<b-form-input v-else-if="data.index >= (dbItems.length)" size="sm" v-model="data.item.email"></b-form-input>
								<b-form-input v-else plaintext size="sm" v-model="data.item.email"></b-form-input>
						</template>
						<template slot="name" slot-scope="data">
								<b-form-input size="sm" v-model="data.item.name"></b-form-input>
						</template>
						<template slot="role" slot-scope="data">
								<b-form-select size="sm" :options="['standard','administrator']" v-bind:disabled="(data.item.email == currentUser.email)" v-model="data.item.role"></b-form-select>
						</template>
						<template slot="active" slot-scope="data">
								<b-form-checkbox :plain="true" v-bind:disabled="((data.item.email == currentUser.email) || (data.index >= dbItems.length))" v-on:change="activeChanged($event,data.index)" v-model="data.item.active"></b-form-checkbox>
						</template>
						<!--
						<template slot="billable" slot-scope="data">
								<b-form-checkbox :plain="true" v-on:change="billableChanged($event,data.index)" v-model="data.item.billable"></b-form-checkbox>
						</template>
						<template slot="billableHistory" slot-scope="row">
							<b-button variant="primary" size="sm" @click.stop="showDetailsClicked($event, row)" class="mr-2">
								{{ row.detailsShowing ? 'Hide' : 'Show'}} History
							</b-button>
						</template>
						<template slot="row-details" slot-scope="row">
							<div>
								&nbsp;&nbsp;&nbsp;&nbsp;{{row.item.name == '' ? (row.item.email == '' ? 'This' : row.item.email) : row.item.name}} is a billable resource for the following periods:
								<div v-for="(element, index) in row.item.billableHistory">
									<b-row>
										<div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
										<b-col cols="2">
											<b-form-input size="sm" v-model="element.start" v-on:change="billableHistoryChanged($event,row.index,index)"></b-form-input>
										</b-col>
										to
										<b-col cols="2">
											<b-form-input size="sm" v-if="(element.end == '') && (row.item.billable) && (index == 0)" plaintext value="present"></b-form-input>
											<b-form-input size="sm" v-else v-model="element.end"></b-form-input>
										</b-col>
									</b-row>
								</div>
							</div>
						</template>
						-->
					</b-table>

					<div v-if="this.subscribed"><small>
						If you change the number of active employees you will also change the number of users in your subscription, see 'Subscription' in the upper right dropdown<br>
						For subscription pricing please visit <a href="https://earnedvalue.app/#pricing" target="_blank">earnedvalue.app/#pricing</a><br>
						For technical assistance please email <a href="mailto:support@earnedvalue.app">support@earnedvalue.app</a>
					</small></div>
					<br>

					<b-alert id="alertMessage" v-bind:variant=this.alertMessage.variant v-bind:show=this.alertMessage.show>{{this.alertMessage.message}}</b-alert>

                    <b-button variant="primary" v-if="this.currentUser.role == 'administrator'" v-on:click="saveClicked">Save</b-button>
					<b-button variant="primary" v-else disabled>Save</b-button>
                    <b-button variant="link" v-on:click="cancelClicked">Cancel</b-button>
					<br><br>

				</b-card>

			</b-col>
		</b-row>
		<!--TODO: this is only for debugging, remove when done-->
		<!--{{this.items}}-->
	</div>

</template>



<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import {stripeData} from '@/shared/stripe-settings'
import axios from 'axios'

export default {
	name: 'employees',

	data: () => {
		return {
			items: [
            ],
            
			fields: {
					email: {label: 'Email', thStyle: {width: '210px', minWidth: '210px'}},
					name: {label: 'Name', thStyle: {width: '210px', minWidth: '210px'}},
					role: {label: 'Role', thStyle: {width: '140px', minWidth: '140px'}},
					active: {label: 'Active', thStyle: {width: '70px'}}
					//billable: {label: 'Billable', thStyle: {width: '70px'}},
					//billableHistory: {label: 'Billable History', thStyle: {width: '70px'}}
            },

			billableHistoryFields: {
					start: {label: 'Start', thStyle: {width: '140px', minWidth: '140px'}},
					end: {label: 'End', thStyle: {width: '140px', minWidth: '140px'}},
			},
			
			dbItems: [
				//{email: 'test09@tmetrack.com', name: 'test 09', role: 'administrator', active: true, billable: true, billableHistory: [{start:'2019-01-01',end:'2019-01-31'},{start:'2019-02-03',end:''}]},
				//{email: 'test@tmetrack.com', name: 'test', role: 'standard', active: true, billable: false, billableHistory: []},
			],
			
			currentUser: {
				cognitoUser: null,
				email: '',
				role: '',
				company: '',
				token: ''
			},
            
			alertMessage: {
				show: false,
				variant: 'success',		//'success' or 'danger'
				message: ''
			},

			subscribed: false,

			cancelRefresh: false,

			loading: true

		}
	},

	mounted() {

		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentUser.cognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.currentUser.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}

						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.currentUser.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.currentUser.role = result[i].getValue();
							else if (result[i].getName() == "email")
								vueInstance.currentUser.email = result[i].getValue();
						}

						axios.get('/user-admin/employees', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								vueInstance.dbItems = JSON.parse(JSON.stringify(response.data));
								vueInstance.items = JSON.parse(JSON.stringify(vueInstance.dbItems));
								for (var i = 0; i < vueInstance.items.length; i++)
									vueInstance.items[i].billableHistory.push({start:'',end:''})
								vueInstance.items.push({email: '', name: '', role: 'standard', active: true, billable: true, billableHistory: [{start:'2001-01-01',end:''},{start:'',end:''}]})
								vueInstance.loading = false;
							})
							.catch(function (error) {
							});

						axios.get('/user-admin/stripe', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								if ((response.data.currentPlan == 'monthly') || (response.data.currentPlan == 'annual'))
									vueInstance.subscribed = true;
							})
							.catch(function (error) {
							});

					});
				}

			});
		}







	},

    updated() {

    },

	methods: {
        showDetailsClicked: function (event, row) {
			row.toggleDetails();
            event.target.blur();
        },

		activeChanged: function (event, index) {	//TODO: assumes event has the new value of active, need to check different browsers
			if (!event) {
				this.items[index].billable = event;
				this.billableChanged(event, index);
			}
        },

		billableChanged: function (event, index) {	//TODO: assumes event has the new value of billable, need to check different browsers
			if (event) {
				this.items[index].active = event;
				this.items[index].billableHistory = [{start:'2001-01-01',end:''},{start:'',end:''}]
			}
			else {
				this.items[index].billableHistory = [{start:'',end:''}]
			}
        },

		billableHistoryChanged: function (event, rowIndex, index) {
			if (index >= (this.items[rowIndex].billableHistory.length - 1))
				this.items[rowIndex].billableHistory.push({start:'',end:''})
		},

        addNewEmployee: function (event) {
			this.items.push({email: '', name: '', role: 'standard', active: true, billable: true, billableHistory: [{start:'2001-01-01',end:''},{start:'',end:''}]})
        },

        cancelClicked: function (event) {
            event.target.blur();
			this.alertMessage.show = false;
			this.alertMessage.variant = 'success';
			this.alertMessage.message = '';
			var vueInstance = this;
			if (this.cancelRefresh) {
				axios.get('/user-admin/employees', {params:{token:vueInstance.currentUser.token}})
					.then(function (response) {
						vueInstance.dbItems = JSON.parse(JSON.stringify(response.data));
						vueInstance.items = JSON.parse(JSON.stringify(vueInstance.dbItems));
						for (var i = 0; i < vueInstance.items.length; i++)
							vueInstance.items[i].billableHistory.push({start:'',end:''})
						vueInstance.items.push({email: '', name: '', role: 'standard', active: true, billable: true, billableHistory: [{start:'2001-01-01',end:''},{start:'',end:''}]})
					})
					.catch(function (error) {
					});
			}
			else {
						vueInstance.items = JSON.parse(JSON.stringify(vueInstance.dbItems));
						for (var i = 0; i < vueInstance.items.length; i++)
							vueInstance.items[i].billableHistory.push({start:'',end:''})
						vueInstance.items.push({email: '', name: '', role: 'standard', active: true, billable: true, billableHistory: [{start:'2001-01-01',end:''},{start:'',end:''}]})
			}
        },

        saveClicked: function (event) {
			event.target.blur();
			var invalidRow = this.validateBillableHistory();
			if (invalidRow != -1) {
				this.alertMessage.variant = 'danger';
				this.alertMessage.message = 'Invalid billable history for ' + (this.items[invalidRow].name == '' ? this.items[invalidRow].email : this.items[invalidRow].name);
				this.alertMessage.show = true;
			}
			else if (this.validateEmail() != -1) {
				this.alertMessage.variant = 'danger';
				this.alertMessage.message = 'Invalid email - employees must have valid email to receive temporary password';
				this.alertMessage.show = true;
			}
			else if (this.validateName() != -1) {
				this.alertMessage.variant = 'danger';
				this.alertMessage.message = 'Invalid name - employee name cannot be empty';
				this.alertMessage.show = true;
			}
			else {
				event.target.disabled = true;
				this.alertMessage.show = false;
				this.alertMessage.variant = 'success';
				this.alertMessage.message = '';
				var saveItems = [];
				var found = false;
				var activeCount = 0;
				var i = 0;
				var j = 0;
				for (i = 0; i < this.items.length - 1; i++) {
					if (this.items[i].active)
						activeCount++;
					found = false;
					j = 0;
					while (!found && (j < this.dbItems.length)) {
						if (this.items[i].email == this.dbItems[j].email) {
							found = true;
							if (JSON.stringify(this.items[i]) != JSON.stringify(this.dbItems[j]))
								saveItems.push(JSON.parse(JSON.stringify(this.items[i])));
						}
						j++;
					}
					if (!found)
						saveItems.push(JSON.parse(JSON.stringify(this.items[i])));
				}
				//alert(JSON.stringify(saveItems))

				var vueInstance = this;
            	axios.put('/user-admin/employees', {token: this.currentUser.token, items: saveItems, users: activeCount})
                .then(function (response) {
						//update dbItems
						for (i = 0; i < saveItems.length; i++) {
							found = false;
							j = 0;
							while (!found && (j < vueInstance.dbItems.length)) {
								if (saveItems[i].email == vueInstance.dbItems[j].email) {
									found = true;
									vueInstance.dbItems[j] = JSON.parse(JSON.stringify(saveItems[i]));
								}
								j++;
							}
							if (!found)
								vueInstance.dbItems.push(JSON.parse(JSON.stringify(saveItems[i])));
						}

						vueInstance.cancelRefresh = false;
						vueInstance.alertMessage.variant = 'success';
						vueInstance.alertMessage.message = 'Employees updated successfully';
						vueInstance.alertMessage.show = true;
						event.target.disabled = false;
                })

                .catch(function (error) {
						//remove saveItems from dbItems so they are included in the save if the user try again
						vueInstance.cancelRefresh = true;
						for (i = 0; i < saveItems.length; i++) {
							found = false;
							j = 0;
							while (!found && (j < vueInstance.dbItems.length)) {
								if (saveItems[i].email == vueInstance.dbItems[j].email) {
									found = true;
									vueInstance.dbItems[j].name = 'DELETE';
								}
								j++;
							}
						}

						vueInstance.alertMessage.variant = 'danger';
						vueInstance.alertMessage.message = 'Update failed. Please try again later.';
						vueInstance.alertMessage.show = true;
						event.target.disabled = false;
                });

			}
        },

		getSundayDateString() {
			var sunday = new Date();
			sunday.setDate(sunday.getDate() - (sunday.getDay() == 0 ? 7 : (sunday.getDay())));
			return (sunday.getFullYear() + '-' + (sunday.getMonth() < 9 ? '0' : '') + (sunday.getMonth() + 1) + '-' + (sunday.getDate() < 10 ? '0' : '') + sunday.getDate());
		},

		getMondayDateString() {
			var monday = new Date();
			monday.setDate(monday.getDate() - (monday.getDay() == 0 ? 6 : (monday.getDay() - 1)));
			return (monday.getFullYear() + '-' + (monday.getMonth() < 9 ? '0' : '') + (monday.getMonth() + 1) + '-' + (monday.getDate() < 10 ? '0' : '') + monday.getDate());
		},

		getTodayDateString() {
			var today = new Date();
			return (today.getFullYear() + '-' + (today.getMonth() < 9 ? '0' : '') + (today.getMonth() + 1) + '-' + (today.getDate() < 10 ? '0' : '') + today.getDate());
		},

		getYesterdayDateString() {
			var today = new Date();
			var yesterday = new Date();
			yesterday.setDate(today.getDate() - 1);
			return (yesterday.getFullYear() + '-' + (yesterday.getMonth() < 9 ? '0' : '') + (yesterday.getMonth() + 1) + '-' + (yesterday.getDate() < 10 ? '0' : '') + yesterday.getDate());
		},

		convertDateStringToDate (dateString) {
			var ymd = dateString.split('-');
			var y = Number(ymd[0]);
			var m = Number(ymd[1]) - 1;
			var d = Number(ymd[2]);
			return new Date(y,m,d);
		},

		validateDateString (dateString) {
			if (dateString.length != 10)
				return false;
			var ymd = dateString.split('-');
			if ((ymd[0].length != 4) || (ymd[1].length != 2) || (ymd[2].length != 2))
				return false;
			if (!((/^\d+$/.test(ymd[0])) && (/^\d+$/.test(ymd[1])) && (/^\d+$/.test(ymd[2]))))
				return false;
			var y = Number(ymd[0]);
			var m = Number(ymd[1]);
			var d = Number(ymd[2]);
			if ((y < 1900) || (y > 2100) || (m < 1) || (m > 12) || (d < 1) || (d > 31))
				return false;
			return true;
		},

		validateBillableHistory () {		//if validated return -1, otherwise return array index of employee with error
			for (var i = 0; i < this.items.length - 1; i++) {
				if (this.items[i].billableHistory.length != 0) {

					//check each row of billableHistory (except first row)
					var j = 1;
					for (j = 1; j < this.items[i].billableHistory.length; j++) {
						if ((this.items[i].billableHistory[j].start == '') && (this.items[i].billableHistory[j].end == '')) {
							//server side will ignore so no need to pop the entry
						}
						else if ((this.items[i].billableHistory[j].start == '') || (this.items[i].billableHistory[j].end == '')) {
							return i;
						}
						else if (!(this.validateDateString(this.items[i].billableHistory[j].start) && this.validateDateString(this.items[i].billableHistory[j].end))) {
							return i;
						}
						
						else if ((this.convertDateStringToDate(this.items[i].billableHistory[j].start).getTime() >= this.convertDateStringToDate(this.items[i].billableHistory[j].end).getTime())
								|| (this.convertDateStringToDate(this.items[i].billableHistory[j].start).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime())
								|| (this.convertDateStringToDate(this.items[i].billableHistory[j].end).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime()))
						{
							return i;
						}
						
					}

					//check first row of billableHistory
					j = 0;
					if (this.items[i].billable) {
						if ((this.items[i].billableHistory[j].start == '') || (this.items[i].billableHistory[j].end != '')) {
							return i;
						}
						else if (!(this.validateDateString(this.items[i].billableHistory[j].start))) {
							return i;
						}
						else if ((this.convertDateStringToDate(this.items[i].billableHistory[j].start).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime())
								|| (this.convertDateStringToDate(this.items[i].billableHistory[j].end).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime()))
						{
							return i;
						}
					}
					else {
						if ((this.items[i].billableHistory[j].start == '') && (this.items[i].billableHistory[j].end == '')) {
							//server side will ignore so no need to pop the entry
						}
						else if ((this.items[i].billableHistory[j].start == '') || (this.items[i].billableHistory[j].end == '')) {
							return i;
						}
						else if (!(this.validateDateString(this.items[i].billableHistory[j].start) && this.validateDateString(this.items[i].billableHistory[j].end))) {
							return i;
						}
						else if ((this.convertDateStringToDate(this.items[i].billableHistory[j].start).getTime() >= this.convertDateStringToDate(this.items[i].billableHistory[j].end).getTime())
								|| (this.convertDateStringToDate(this.items[i].billableHistory[j].start).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime())
								|| (this.convertDateStringToDate(this.items[i].billableHistory[j].end).getTime() > this.convertDateStringToDate(this.getTodayDateString()).getTime()))
						{
							return i;
						}
					}
					
				}
				else if (this.items[i].billable) {
					return i;
				}
			}
			return -1;
		},

		validateEmail () {		//if validated return -1, otherwise return array index of employee with error
			var splitEmail;
			var emailList = [];
			for (var i = 0; i < this.items.length - 1; i++) {
				if (this.items[i].email == '')
					return i;
				else {
					splitEmail = this.items[i].email.split('@');
					if (splitEmail.length != 2)
						return i;
					else if ((splitEmail[0] == '') || (splitEmail[1] == ''))
						return i;
					var currentEmail = this.items[i].email;
					if (emailList.indexOf(currentEmail) !== -1)		//check for duplicated email
						return i;
					emailList.push(currentEmail);
				}
			}
			return -1;
		},

		validateName () {		//if validated return -1, otherwise return array index of employee with error
			for (var i = 0; i < this.items.length - 1; i++) {
				if (this.items[i].name == '')
					return i;
			}
			return -1;
		}




	}


}
</script>



<style>

.custom-select-sm {
	font-size: 0.76563rem;
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
}

</style>
